var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"auth-button",on:{"click":function($event){return _vm.modalsSetShow('Login')}}},[_c('div',{staticClass:"button-inner"},[_vm._v(" SIGN IN ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }